import React, { useEffect, useState } from "react";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { ServiceUrl } from "../../utils/serviceUrl";
import { DB_POSTFIX, getFileLiveUrl } from "../../utils";
const GalleryList = () => {
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    setError("");

    axios
      .get(`${ServiceUrl.LIST_GALLERY}?sadb=${DB_POSTFIX}&limit=6`)
      .then((res) => {
        console.log("Gallery API Response:", res.data);

        if (res.data?.status === "1") {
          setDataList(res.data.data || []);
        } else {
          setError("No gallery data found.");
          setDataList([]);
        }

        setLoader(false);
      })
      .catch((err) => {
        console.error("Error fetching gallery:", err);
        setError("Failed to load gallery. Please try again later.");
        setLoader(false);
      });
  };

  return (
    <section>
      <div className="container">
        <h3 className="announcement-title">Gallery</h3>
        {loader && (
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
            <p>Loading gallery...</p>
          </div>
        )}

        {!loader && error && (
          <div className="alert alert-danger text-center">{error}</div>
        )}

        {!loader && !error && dataList.length > 0 && (
          <div className="row mt-2">
            {dataList.map((item, index) => (
              <div className="col-md-6 mb-4" key={index}>
                <div
                  className="card shadow-sm border-0"
                  style={{ width: "140px" }}
                >
                  <img
                    src={
                      item.feature_image
                        ? getFileLiveUrl(item.feature_image)
                        : "/default-image.png"
                    }
                    alt={item.title || "Gallery"}
                    className="card-img-top img-fluid"
                    style={{ width: "140px", objectFit: "cover" }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}

        {!loader && !error && dataList.length === 0 && (
          <p className="text-center text-muted">No gallery items available.</p>
        )}
        <div className="footer-btn">
          <a href="/events">View All</a>
        </div>
      </div>
    </section>
  );
};

export default GalleryList;
